module.exports = "/assets/images/credit-card_c6d8c0.svg";